export function numberToCurrencyFormat(value) {
  if (value === null || value === undefined) return "";
  
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}
